import { CheckNotes, InspectionCase } from '../inspection-cases';

export class SirensAndMarkingLampsDto extends InspectionCase {
  item_10_1?: InspectionCase;
  item_10_2?: InspectionCase;
  item_10_3?: InspectionCase;
  item_10_4?: InspectionCase;
  item_10_5?: InspectionCase;
  item_10_6?: InspectionCase;
  item_10_7?: InspectionCase;
}

export class SirensAndMarkingLamps extends SirensAndMarkingLampsDto {
  constructor(
    data: SirensAndMarkingLampsDto = { title: 'צופרים ומנורות סימון' }
  ) {
    super(data);
    this.item_10_1 = new InspectionCase({
      ...data.item_10_1,
      title: `קווי הצופרים מבוקרים נגד נתק ונשמעים היטב במבנה. כמו כן קו זינה 24 וולט לכרטיס הצופרים מבוקר נתק (כניסה ויציאה בכרטיס)`
    });
    this.item_10_2 = new InspectionCase({
      ...data.item_10_2,
      title: `עוצמת הצפירה של הצופרים גדולה ב-5 ד"ב מרעש הסביבה הנמדד בגובה של 1.5 מ' מעל הרצפה`
    });
    this.item_10_3 = new InspectionCase({
      ...data.item_10_3,
      title: `כל הצופרים והלחצנים שמחוץ למבנה מתאימים להתקנה חיצונית ויותקנו בחזית המבנה`
    });
    this.item_10_4 = new InspectionCase({
      ...data.item_10_4,
      title: `במקומות רועשים כגון דיסקוטקים וכדו... הותקנו נצנצים`
    });
    this.item_10_5 = new InspectionCase({
      ...data.item_10_5,
      title: `
      בבתי מלונות ,, בתי אבות , בתי הבראה ונופש , בתי חולים ובמקומות עם התקהלויות הותקנו נצנצים (עבור חרשים). ההתקנים מותקנים במסדרונות ובכניסה או בקבלה.
      גובה הנצנץ מהרצפה יהיה בין 2.2 -3.5 מ' מהרצפה
      `
    });
    this.item_10_6 = new InspectionCase({
      ...data.item_10_6,
      title: `הותקנו לחצנים ידניים ליד פתחי יציאות חירום ובכניסה לכל אזור`
    });
    this.item_10_7 = new InspectionCase({
      ...data.item_10_7,
      title: `קיים מכסה הגנה מפלסטיק על גבי הלחצנים למניעת הפעלת שווא`
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.item_10_1.isApplicable || this.item_10_1.isPassed) &&
        (!this.item_10_2.isApplicable || this.item_10_2.isPassed) &&
        (!this.item_10_3.isApplicable || this.item_10_3.isPassed) &&
        (!this.item_10_4.isApplicable || this.item_10_4.isPassed) &&
        (!this.item_10_5.isApplicable || this.item_10_5.isPassed) &&
        (!this.item_10_6.isApplicable || this.item_10_6.isPassed) &&
        (!this.item_10_7.isApplicable || this.item_10_7.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.item_10_1.getNotes(),
      ...this.item_10_2.getNotes(),
      ...this.item_10_3.getNotes(),
      ...this.item_10_4.getNotes(),
      ...this.item_10_5.getNotes(),
      ...this.item_10_6.getNotes(),
      ...this.item_10_7.getNotes()
    ];
  }
}
